module.exports = __webpack_public_path__ + "img/logo_weiss.edb838c0.png";